
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface SpeedometerChartProps {
  percentage: number;
}

export const SpeedometerChart: React.FC<SpeedometerChartProps> = ({ percentage }) => {
  const clampedPercentage = Math.min(100, Math.max(0, percentage));
  const normalizedPercentage = clampedPercentage > 0 ? Math.max(5, clampedPercentage) : 0;
  
  const data = [
    { name: "remaining", value: 100 - normalizedPercentage },
    { name: "progress", value: normalizedPercentage }
  ];

  // Colors for the gauge segments
  const COLORS = ["#f3f4f6", "#9b87f5"];

  return (
    <div className="relative h-[300px] w-[300px]">
      {/* Percentage display in the center */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-4xl font-bold">{clampedPercentage.toFixed(1)}%</div>
      </div>
      
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            startAngle={180}
            endAngle={0}
            innerRadius={100}
            outerRadius={140}
            paddingAngle={0}
            dataKey="value"
            stroke="none"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      
      {/* Labels for the gauge */}
      <div className="absolute bottom-0 left-0 text-xs">0%</div>
      <div className="absolute bottom-0 right-0 text-xs">100%</div>
    </div>
  );
};
